import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ArrowForwardIos } from '@mui/icons-material';
import { Grid } from '@mui/material';

import { userAdminGroup } from 'commons/types/userGroup';
import { CheckUserRoles } from 'commons/utils/checkUserRoles';
import {
  INBOUND_ROUTES,
  REPLENISH_ROUTES,
  STOCK_TRANSFER_ROUTES,
} from 'routes/constants';

import UserInfoHeader from './components/UserInfoHeader.component';
import S from './HomePage.styles';

const HomePageInbound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div>
      <UserInfoHeader />
      {/* Menu Options */}
      {/* Replenishment */}
      <S.MenuOption
        onClick={() => navigate(REPLENISH_ROUTES.ASSIGN)}
        data-testid="BtnMenuReplenishment"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon
              src="/assets/replenishment-icon.svg"
              alt="replenishment-icon"
            />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Replenishment</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>

      {/* Bin Transfer */}
      <S.MenuOption
        onClick={() => navigate(STOCK_TRANSFER_ROUTES.LIST_SOURCE)}
        data-testid="BtnMenuStockTransfer"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon
              src="/assets/stock-transfer-icon.svg"
              alt="stock-transfer-icon"
            />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Bin Transfer</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>

      {/* Inbound Task */}
      <S.MenuOption
        onClick={() => navigate(INBOUND_ROUTES.ASSIGN)}
        data-testid="BtnMenuInboundTask"
      >
        <Grid container>
          <Grid item xs={2}>
            <S.MenuIcon
              src="/assets/inbound-task-icon.svg"
              alt="inbound-task-icon"
            />
          </Grid>
          <Grid item xs={8}>
            <S.MenuText>Inbound Task</S.MenuText>
          </Grid>
          <Grid item xs={2}>
            <ArrowForwardIos
              fontSize="small"
              style={{ marginTop: 14, textAlign: 'right' }}
            />
          </Grid>
        </Grid>
      </S.MenuOption>

      {/* Inbound Approval */}
      {CheckUserRoles(userAdminGroup) ? (
        <S.MenuOption
          onClick={() => navigate(INBOUND_ROUTES.APPROVAL_LIST)}
          data-testid="BtnMenuInboundApproval"
        >
          <Grid container>
            <Grid item xs={2}>
              <S.MenuIcon
                src="/assets/inbound-approval-icon.svg"
                alt="inbound-approval-icon"
              />
            </Grid>
            <Grid item xs={8}>
              <S.MenuText>Inbound Approval</S.MenuText>
            </Grid>
            <Grid item xs={2}>
              <ArrowForwardIos
                fontSize="small"
                style={{ marginTop: 14, textAlign: 'right' }}
              />
            </Grid>
          </Grid>
        </S.MenuOption>
      ) : null}
    </div>
  );
};
export default HomePageInbound;
